import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "@redux-saga/core";
import rootSaga from "./rootSaga";
import rootReducer from "./rootReducer";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  createTransform,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import SessionManager from "../services/auth/sessionManager";

// Create a transform that removes sensitive fields before persisting
const userPersistTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  (inboundState: any, key) => {
    if (key === "user") {
      const clone = { ...inboundState };
      // remove isAuthenticated before persisting
      delete clone.isAuthenticated;
      delete clone.loading;
      return clone;
    }
    return inboundState;
  },
  // transform state being rehydrated
  (outboundState: any, key) => {
    if (key === "user") {
      // After rehydrate, recompute isAuthenticated from SessionManager
      return {
        ...outboundState,
        isAuthenticated: SessionManager.hasValidToken(),
      };
    }
    return outboundState;
  },
);

const persistConfig = {
  key: "bbps",
  storage,
  whitelist: ["user"], // we persist user slice but remove sensitive fields via transform
  transforms: [userPersistTransform],
};

// const persistedReducer = persistReducer(persistConfig, rootReducer);
const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(
  persistConfig,
  rootReducer,
);

// const initialState = {};
const sagaMiddleware = createSagaMiddleware();

// state ko localStorage se load karna
// const loadState = () => {
//   try {
//     const serializedState = localStorage.getItem("reduxState");
//     if (!serializedState) return undefined;
//     return JSON.parse(serializedState);
//   } catch {
//     return undefined;
//   }
// };

// state ko localStorage me save karna
// const saveState = (state: RootState) => {
//   try {
//     const serializedState = JSON.stringify(state);
//     localStorage.setItem("reduxState", serializedState);
//   } catch {
//     // ignore
//   }
// };

export const store = configureStore({
  reducer: persistedReducer, //rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      // immutableCheck: true,
      thunk: true,
    }).concat([sagaMiddleware]),
  // preloadedState: initialState,
  // preloadedState: loadState(),
  // devTools: process.env.NODE_ENV !== "production",
});

// store.subscribe(() => {
//   saveState(store.getState()); // har update ke baad save
// });

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
